// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frisbuy-slide-wrapper-elements .frisbuy-slide-wrapper-elements__header .frisbuy-advertising-marker{position:relative;width:-moz-fit-content;width:fit-content;margin-top:12px;z-index:3}.frisbuy-slide-wrapper-elements .frisbuy-slide-wrapper-elements__header .frisbuy-advertising-marker .frisbuy-popover__tooltip{width:calc(100vw - 14px);max-width:340px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
